import {useEffect, useState} from "react";
import {Listbox} from "@headlessui/react";
import IconNext from "../../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";
import {FilterAnyLabels} from "../../data/Filter/Filter.config";
import {enforceArray} from "../../helpers/FilterFunctions";
import {VermietungSortingOptions} from "../../data/Filter/VermietungFilter.config";
import {useTranslation} from "next-i18next";
import {Float} from "@headlessui-float/react";

export type Item = {
	name: string;
};

interface CustomListboxProps {
	items: Item[];
	onSelectItems?: (items: Item[]) => void;
	defaultChecked?: Item[];
	singleChoice?: boolean;
	noCheckBox?: boolean;
}

function CustomListbox(props: CustomListboxProps) {
	const {t} = useTranslation();
	const [openOnTop, setOpenOnTop] = useState(false);

	const [selectedItems, setSelectedItems] = useState<Item[]>(
		props.defaultChecked || []
	);

	useEffect(() => {
		if (
			selectedItems.length > 0 &&
			props.onSelectItems &&
			JSON.stringify(props.defaultChecked) != JSON.stringify(selectedItems)
		) {
			props.onSelectItems(selectedItems);
		}
	}, [selectedItems]);

	useEffect(() => {
		if (props.defaultChecked) setSelectedItems(props.defaultChecked);
	}, [props.defaultChecked]);

	function handleSelect(items: Item[]) {
		if (
			(items.length > 0 &&
				items[items.length - 1].name === FilterAnyLabels.BELIEBIG) ||
			items.length === 0
		) {
			setSelectedItems([{name: FilterAnyLabels.BELIEBIG}] as Item[]);
		} else if (props.singleChoice) {
			setSelectedItems(items);
		} else {
			setSelectedItems(
				items.filter((item) => item.name != FilterAnyLabels.BELIEBIG)
			);
		}
	}

	return (
		<div>
			<Listbox
				value={props.singleChoice ? selectedItems[0] : selectedItems}
				onChange={(v: Item[]) => {
					handleSelect(enforceArray(v));
				}}
				multiple={props.singleChoice ? false : true}
				by={"name"}
				as={"div"}
				className={`relative`}
			>
				<Float flip>
					<Listbox.Button
						className={`relative w-full cursor-default bg-white py-2 pl-3 pr-10 text-left ${"input-field"} focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm lg:h-[40px]`}
						onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
							const menuHeight = 35 * props.items.length;
							if (typeof window !== "undefined") {
								setOpenOnTop(
									window.innerHeight -
									e.currentTarget.getBoundingClientRect().bottom <
									menuHeight
								);
							}
						}}
					>
            <span className="block truncate  text-[12px] md:text-[16px]">
              {selectedItems.length === 0 ? (
	              <div className="text-leo-placeholder-gray">
		              {t(FilterAnyLabels.BELIEBIG)}
	              </div>
              ) : (
	              <div
		              className={`${
			              selectedItems.find(
				              (i) =>
					              i.name === FilterAnyLabels.BELIEBIG ||
					              i.name === VermietungSortingOptions[0].label
			              )
				              ? "text-leo-placeholder-gray"
				              : ""
		              }`}
	              >
		              {selectedItems
			              .map((item) => {
				              return t(item.name);
			              })
			              .sort()
			              .join(" / ")}
	              </div>
              )}
            </span>
						<span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <IconNext className="h-4 w-4" aria-hidden="true"/>
            </span>
					</Listbox.Button>
					<Listbox.Options
						className={`max-h-100 py-1 text-base leading-6 overflow-auto focus:outline-none shadow-md px-2 absolute bg-white ${
							openOnTop ? "bottom-full" : "top-full"
						}  w-fit z-20`}
					>
						{props.items.map((item) => {
							return (
								<Listbox.Option key={item.name} value={item}>
									{({active, selected}) => (
										<div
											className={`h-[35px] select-none relative py-1 pr-4 cursor-pointer ${
												props.noCheckBox ? "pl-1" : "pl-8"
											}`}
										>
											<span className={`block truncate`}>{t(item.name)}</span>
											<span
												className={`absolute inset-y-0 left-0 flex items-center pl-1.5`}
											>
                        {!props.noCheckBox && (
	                        <input
		                        type="checkbox"
		                        readOnly
		                        className="h-3.5 w-3.5 checked:bg-leo-dark-brown shadow-md pointer-events-none border-none"
		                        checked={selected}
	                        />
                        )}
                      </span>
										</div>
									)}
								</Listbox.Option>
							);
						})}
					</Listbox.Options>
				</Float>
			</Listbox>
		</div>
	);
}

export default CustomListbox;
